import React, { useEffect, useState } from 'react';
import { apiRequest } from './utils';
import translations from './lang';
import './ClientList.css';

const ClientList = () => {
  const language = localStorage.getItem('language') || 'ro';
  const t = translations[language];

  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchClients = () => {
    apiRequest(`${process.env.REACT_APP_API}/api/clients/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        'Accept-Language': language
      }
    })
      .then(res => res.json())
      .then(data => {
        setClients(data.data || []);
      })
      .catch(err => console.error('Hiba a kliensek lekérdezésekor:', err))
      .finally(() => setLoading(false));
  };

  const toggleBlockStatus = (userId, shouldBlock) => {
    const endpoint = shouldBlock ? 'block-client' : 'unblock-client';
    apiRequest(`${process.env.REACT_APP_API}/api/${endpoint}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        'Accept-Language': language
      },
      body: JSON.stringify({ user_id: userId })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          fetchClients();
        } else {
          alert(data.error || t.update_status_failed);
        }
      })
      .catch(err => console.error('Hiba a kliens státuszának módosításakor:', err));
  };

  if (loading) return <div className="client-list loading">{t.loading_data}</div>;

  return (
    <div className="client-list">
      <h3 className="client-title">{t.client_list}</h3>

      {/* Asztali / Tablet: klasszikus táblázat */}
      <div className="table-wrapper desktop-only">
        <table className="client-table">
          <thead>
            <tr>
              <th>{t.name}</th>
              <th>{t.email}</th>
              <th>{t.phone_number}</th>
              <th>{t.status}</th>
              <th>{t.actions}</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((client, index) => (
              <tr key={index}>
                <td>{client.client_name}</td>
                <td>{client.client_email}</td>
                <td>{client.client_phone}</td>
                <td className={client.is_blocked ? 'status blocked' : 'status active'}>
                  {client.status}
                </td>
                <td>
                  <button
                    className={client.is_blocked ? 'unblock-btn' : 'block-btn'}
                    onClick={() => toggleBlockStatus(client.user, !client.is_blocked)}
                  >
                    {client.is_blocked ? t.unblock : t.block}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobil: két soros kártyák */}
      <div className="cards-wrapper mobile-only">
        {clients.map((client, index) => (
          <div className="client-card" key={index}>
            <div className="row row-top">
              <div className="cell name">
                <span className="label">{t.name}</span>
                <span className="value">{client.client_name}</span>
              </div>
              <div className="cell phone">
                <span className="label">{t.phone_number}</span>
                <span className="value">{client.client_phone}</span>
              </div>
            </div>

            <div className="row row-bottom">
              <div className="cell email">
                <span className="label">{t.email}</span>
                <span className="value break">{client.client_email}</span>
              </div>
              <div className="cell actions">
                <div className="status-wrap">
                  <span className={`status-badge ${client.is_blocked ? 'blocked' : 'active'}`}>
                    {client.status}
                  </span>
                  <button
                    className={client.is_blocked ? 'unblock-btn' : 'block-btn'}
                    onClick={() => toggleBlockStatus(client.user, !client.is_blocked)}
                  >
                    {client.is_blocked ? t.unblock : t.block}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientList;
